import { render, staticRenderFns } from "./AllocationRotaSteps.vue?vue&type=template&id=8a34d012"
import script from "./AllocationRotaSteps.vue?vue&type=script&lang=js"
export * from "./AllocationRotaSteps.vue?vue&type=script&lang=js"
import style0 from "./AllocationRotaSteps.vue?vue&type=style&index=0&id=8a34d012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports